module.exports = __webpack_public_path__ + "static/media/Rectangle 29.654cb663.png";